export const DMNNMSTTG = {
    // DMNNM : 'tradeprint',
    DMNNM: 'metaodds',
    // DMN : 'in',
    DMN: 'net',
    SKTPRT: ['5011', '6011'],
    chkallw: true
}
